<!-- Used for Index icons. Requires 'icon' prop (e.g. icon="arrow-left") -->
<template>
  <span :class="['icon-' + icon, 'fa-' + size]" />
</template>

<script>
export default {
  name: "Icon",
  props: {
    icon: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md"
    }
  }
};
</script>

<style scoped>
[class^="icon-"],
[class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "IndexIcons" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-mdoothing: antialiased;
  -moz-osx-font-mdoothing: grayscale;
}

.icon-trash:before {
  content: "\e919";
}
.icon-cog:before {
  content: "\e91a";
}
.icon-save:before {
  content: "\e918";
}
.icon-plus:before {
  content: "\e915";
}
.icon-minus:before {
  content: "\e916";
}
.icon-checkmark:before {
  content: "\e913";
}
.icon-cross:before {
  content: "\e912";
}
.icon-arrow-up:before {
  content: "\e903";
}
.icon-arrow-down:before {
  content: "\e900";
}
.icon-arrow-left:before {
  content: "\e901";
}
.icon-arrow-right:before {
  content: "\e902";
}
.icon-arrow-up-short:before {
  content: "\e911";
}
.icon-arrow-down-short:before {
  content: "\e90e";
}
.icon-arrow-left-short:before {
  content: "\e90f";
}
.icon-arrow-right-short:before {
  content: "\e910";
}
.icon-heart-square:before {
  content: "\e914";
}
.icon-body:before {
  content: "\e904";
}
.icon-home:before {
  content: "\e907";
}
.icon-work:before {
  content: "\e90c";
}
.icon-play-learning:before {
  content: "\e908";
}
.icon-community:before {
  content: "\e905";
}
.icon-peoples-choice:before {
  content: "\e906";
}
.icon-explore:before {
  content: "\e909";
}
.icon-order:before {
  content: "\e90a";
}
.icon-play:before {
  content: "\e90b";
}
.icon-search:before {
  content: "\e90d";
}
.icon-filter:before {
  content: "\e917";
}

.fa-xs {
  font-size: 0.75em;
}
.fa-sm {
  font-size: 0.875em;
}
.fa-md {
  font-size: 1em;
}
.fa-lg {
  font-size: 1.333em;
}
.fa-2x {
  font-size: 2em;
}
.fa-3x {
  font-size: 3em;
}
.fa-4x {
  font-size: 4em;
}
.fa-5x {
  font-size: 5em;
}
.fa-6x {
  font-size: 6em;
}
.fa-7x {
  font-size: 7em;
}
.fa-8x {
  font-size: 8em;
}
.fa-9x {
  font-size: 9em;
}
.fa-10x {
  font-size: 10em;
}
</style>